import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

const DeleteView = ({ idItems, fetchData }: DeleteProduct) => {
  const handleDeleteBranch = async () => {
    const res = await repositoryMdm.post<MessageResponse<boolean>>(
      "/api/v1/TblRequestTransfer/delete",
      idItems.map((id) => Number(id))
    );
    if (res)
      if (res.success) {
        NotificationExtension.Success("Xóa thành công !");
        fetchData();
      } else NotificationExtension.Fails("Xóa thất bại !");
    modals.closeAll();
  };

  return (
    <div>
      <Text size="20px" mt={5}>
        Bạn có chắc chắn muốn xóa các đơn chuyển kho này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDeleteBranch}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItems: (number | string)[];
  fetchData: any;
};

export default DeleteView;
